export default "__VITE_ASSET__BQPkjoqZ__"